const positions = [
  { value: '1', name: 'Speaker', category: 'Presiding Officer', level: '1', shortName: 'Speaker' },
  { value: '2', name: 'Deputy Speaker', category: 'Presiding Officer', level: '1', shortName: 'Deputy Speaker' },
  {
    value: '3',
    name: 'Chairperson of Committees',
    category: 'Presiding Officer',
    level: '1',
    shortName: 'Chairperson',
  },
  {
    value: '4',
    name: 'Deputy Chairperson of Committees',
    category: 'Presiding Officer',
    level: '1',
    shortName: 'Deputy Chairperson',
  },
  { value: '5', name: 'Premier', category: 'Members of the Executive Council', level: '2', shortName: 'MEC' },
  {
    value: '6',
    name: 'MEC of Transport, Safety and Liaison',
    category: 'Members of the Executive Council',
    level: '2',
    shortName: 'MEC',
  },
  {
    value: '7',
    name: 'MEC of Cooperative Governance and Traditional Affairs',
    category: 'Members of the Executive Council',
    level: '2',
    shortName: 'MEC',
  },
  { value: '8', name: 'MEC of Education', category: 'Members of the Executive Council', level: '2', shortName: 'MEC' },
  {
    value: '9',
    name: 'MEC of Finance, Economic Development, Environmental Affairs and Tourism',
    category: 'Members of the Executive Council',
    level: '2',
    shortName: 'MEC',
  },
  { value: '10', name: 'MEC of Health', category: 'Members of the Executive Council', level: '2', shortName: 'MEC' },
  {
    value: '11',
    name: 'MEC of Human Settlements',
    category: 'Members of the Executive Council',
    level: '2',
    shortName: 'MEC',
  },
  {
    value: '12',
    name: 'MEC of Public Works',
    category: 'Members of the Executive Council',
    level: '2',
    shortName: 'MEC',
  },
  {
    value: '13',
    name: 'MEC of Rural Development & Agrarian Reform',
    category: 'Members of the Executive Council',
    level: '2',
    shortName: 'MEC',
  },
  {
    value: '14',
    name: 'MEC of Social Development',
    category: 'Members of the Executive Council',
    level: '2',
    shortName: 'MEC',
  },
  {
    value: '15',
    name: 'MEC of Sport, Recreation, Arts and Culture',
    category: 'Members of the Executive Council',
    level: '2',
    shortName: 'MEC',
  },
  {
    value: '16',
    name: 'Chief Whip of the Majority Party',
    category: 'Leaders of Political Parties',
    level: '3',
    shortName: 'Leader',
  },
  {
    value: '17',
    name: 'Leader of the Official Opposition Party',
    category: 'Leaders of Political Parties',
    level: '3',
    shortName: 'Leader',
  },
  { value: '18', name: 'Leader of the EFF', category: 'Leaders of Political Parties', level: '3', shortName: 'Leader' },
  { value: '19', name: 'Leader of the UDM', category: 'Leaders of Political Parties', level: '3', shortName: 'Leader' },
  { value: '20', name: 'Leader of the ATM', category: 'Leaders of Political Parties', level: '3', shortName: 'Leader' },
  {
    value: '21',
    name: 'Leader of the FF Plus',
    category: 'Leaders of Political Parties',
    level: '3',
    shortName: 'Leader',
  },
  {
    value: '22',
    name: 'Chairperson - Social Needs Cluster',
    category: 'Chairpersons of Portfolio/Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '23',
    name: 'Chairperson - Economic Needs Cluster',
    category: 'Chairpersons of Portfolio/Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '24',
    name: 'Chairperson - Governance Needs Cluster',
    category: 'Chairpersons of Portfolio/Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '25',
    name: 'Chairperson - Standing Committee on Public Participation, Petitions and Public Education',
    category: 'Chairpersons of Portfolio/Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '26',
    name: 'Chairperson - Standing Committee on Special Programmes',
    category: 'Chairpersons of Portfolio/Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '27',
    name: "Chairperson - Standing Committee on Women's Caucus",
    category: 'Chairpersons of Portfolio/ Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '28',
    name: 'Chairperson - Standing Committee on Public Accounts',
    category: 'Chairpersons of Portfolio / Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '29',
    name: 'Chairperson - Standing Committee on Law Review',
    category: 'Chairpersons of Portfolio / Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '30',
    name: 'Chairperson - Legislature Oversight Committee',
    category: 'Chairpersons of Portfolio / Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '31',
    name: 'Chairperson - Portfolio Committee on Cooperative Governance and Traditional Affairs',
    category: 'Chairpersons of Portfolio / Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '32',
    name: 'Chairperson - Portfolio Committee on Education',
    category: 'Chairpersons of Portfolio / Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '33',
    name: 'Chairperson - Portfolio Committee on Economic Development, Environmental Affairs and Tourism',
    category: 'Chairpersons of Portfolio / Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '34',
    name: 'Chairperson - Portfolio Committee on Finance and Provincial Treasury',
    category: 'Chairpersons of Portfolio / Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '35',
    name: 'Chairperson - Portfolio Committee on Health',
    category: 'Chairpersons of Portfolio / Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '36',
    name: 'Chairperson - Portfolio Committee on Human Settlements',
    category: 'Chairpersons of Portfolio / Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '37',
    name: 'Chairperson - Portfolio Committee on Office of the Premier',
    category: 'Chairpersons of Portfolio / Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '38',
    name: 'Chairperson - Portfolio Committee on Public Works',
    category: 'Chairpersons of Portfolio / Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '39',
    name: 'Chairperson - Portfolio Committee on Roads and Transport',
    category: 'Chairpersons of Portfolio / Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '40',
    name: 'Chairperson - Portfolio Committee on Rural Development and Agrarian Reform',
    category: 'Chairpersons of Portfolio / Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '41',
    name: 'Chairperson - Portfolio Committee on Safety and Liaison',
    category: 'Chairpersons of Portfolio / Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '42',
    name: 'Chairperson - Portfolio Committee on Social Development',
    category: 'Chairpersons of Portfolio / Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '43',
    name: 'Chairperson - Portfolio Committee on Sport, Recreation, Arts and Culture',
    category: 'Chairpersons of Portfolio / Standing Committees',
    level: '4',
    shortName: 'Chairperson',
  },
  {
    value: '44',
    name: 'Chief Whip of the Majority Party',
    category: 'Whips of the Legislature',
    level: '5',
    shortName: 'Chief Whip',
  },
  {
    value: '45',
    name: 'Deputy Chief Whip',
    category: 'Whips of the Legislature',
    level: '5',
    shortName: 'Deputy Chief Whip',
  },
  {
    value: '46',
    name: 'Chief Whip of the Opposition Party',
    category: 'Whips of the Legislature',
    level: '5',
    shortName: 'Chief Whip',
  },
  {
    value: '47',
    name: 'Whip',
    category: 'Whips of the Legislature',
    level: '5',
    shortName: 'Whip',
  },
  {
    value: '48',
    name: 'Member of the Provincial Legislature',
    category: 'Members of the Provincial Legislature',
    level: '6',
    shortName: 'MPL',
  },
  {
    value: '49',
    name: 'Caucus Chairperson',
    category: 'Members of the Provincial Legislature',
    level: '6',
    shortName: 'Chairperson',
  },
  {
    value: '50',
    name: 'Chairperson of Committees',
    category: 'Chairpersons of Portfolio/Standing Committees',
    level: '1',
    shortName: 'Chairperson',
  },
];
export default positions;
